import { H6, Image, P } from "../../../../../../../AbstractElements";
import { CurrentCartTableBodyData } from "../../../../../../../Data/Forms&Table/Forms/FormLayout";
import { dynamicImage } from "../../../../../../../Utils";

const CurrentCartTableBody = () => {
  return (
    <tbody>
      {CurrentCartTableBodyData.map((data, index) => (
        <tr key={index}>
          <td><Image src={dynamicImage(data.imagePath)} alt="t-shirt" /></td>
          <td>
            <div>
              <H6>{data.productName}</H6>
              <span>{data.productSum}</span>
            </div>
          </td>
          <td><P>{data.price}</P></td>
        </tr>
      ))}
    </tbody>
  );
};
export default CurrentCartTableBody